import { useDemonstracao } from './demonstracao.ts';
import { temAcessoTotal, useIdentidade } from './identidade.ts';

/**
 * Percorrer qualquer lição sem cumprir os pré-requisitos, e o único sítio onde
 * isso se decide.
 *
 * São duas peças complementares, e nenhuma serve sozinha:
 *
 * - **O modo de demonstração** (`state/demonstracao.ts`) é um botão no
 *   catálogo, sem conta nenhuma, e **não existe no pacote de produção** — a
 *   condição é resolvida na compilação e o empacotador apaga o código.
 * - **A conta de acesso total** (migração 20260809000100) é uma linha na base
 *   de dados, chega por `/api/eu`, e é o que funciona em code.yelela.net.
 *
 * Estarem juntos aqui é o que evita o modo de falha previsível: três ecrãs
 * decidem bloqueio — o caminho do módulo, os nós do caminho e a rota da lição,
 * esta última porque o endereço directo tem de ser recusado — e uma condição
 * acrescentada a dois deles deixa o terceiro a trancar uma lição que os outros
 * mostram aberta.
 *
 * Continua a não ser pagamento: salta a sequência pedagógica, nunca uma
 * subscrição. Ver `content/estado.ts`.
 */
export function useDesbloqueioTotal(): boolean {
  const demonstracao = useDemonstracao((s) => s.activo);
  const acessoTotal = useIdentidade(temAcessoTotal);
  return demonstracao || acessoTotal;
}
